export const AvatarsEndpoints = Object.freeze({
	avatar_list: "/v3/assets/avatars",
});
